import type {
  DtoApplication,
  DtoApplicationBorrower,
} from "@porchpass/api-client";
import type { BorrowerInviteHandlerParams } from "src/types/dashboard";

export const handleApplicationProgressRoute = (
  application: DtoApplication,
  authBorrower: DtoApplicationBorrower,
  mainBorrower: string | undefined,
  { setUserData, navigate, dealerName }: BorrowerInviteHandlerParams,
) => {
  const { id: application_id } = application;
  const { status, is_primary, id: auth_borrower_id } = authBorrower;
  setUserData?.((prev) => ({
    ...prev,
    application_id: application_id,
    borrower_id: mainBorrower,
    auth_user_borrower_id: auth_borrower_id,
    status,
    is_primary,
  }));
  navigate(`/${dealerName}/application/${application_id}/progress`);
};
